// extracted by mini-css-extract-plugin
module.exports = {"targetPower":"styles_targetPower__3jpfZ","target":"styles_target__26sWl","powerLevel":"styles_powerLevel__1fHva","powerAvatar":"styles_powerAvatar__1RXbW"};